import React, { useState } from "react";
import {
  DialogContent,
  Card,
  DialogActions,
  Button,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  CardContent,
  Checkbox,
  TableRow,
} from "@material-ui/core";
import Colors from "shared/color";
import CustomInput from "components/custom/CustomInput";
import { toastSuccess, toastWarning } from "shared/utils";

const TCell = (props) => {
  const {style,children,...rest} = props
  return (
    <TableCell
      style={{
        border: "none",
        fontSize: "0.8125rem",
        padding: " 3px",
        ...style,
      }}
      {...rest}
    >
      {children}
    </TableCell>
  );
};

export const VerifyPayment = ({ handleClose, paymentRef, api,paymentMode }) => {
  const [utr, setUtr] = useState("");
  const [razorpay_order_id, setrazorpay_order_id ] = useState(null)
  const [isSubmitting, setisSubmitting] = useState(false)
  const [duplicate, setDuplicate] = useState(false);
  const [successStatement, setSuccessStatement] = useState(false);

  const verifyPaymentHandler = (e) => {
    e.preventDefault();
    setisSubmitting(true);
    let reqData = {};
    if (utr.length) {
      reqData = { utr_number: utr };
      
      if (duplicate) {
        reqData["mark_as_duplicate"] = true;
      }
      if (successStatement) {
        reqData["mark_statement_success"] = true;
      }
    }
    if(paymentMode && paymentMode==="RAZORPAY"){
      if(razorpay_order_id){
        reqData["razorpay_order_id"] =razorpay_order_id;  
      }
    }

    api(paymentRef, reqData)
      .then((res) => {
        setisSubmitting(false);
        if (res.success) {
          toastSuccess(res.message);
          handleClose(true);
        } else {
          toastWarning(res.message);
        }
      })
      .catch((error) => {
        setisSubmitting(false);
      });
  };

  return (
    <>
      <DialogContent
        dividers={false}
        style={{
          backgroundColor: Colors["lighterPurple"],
          fontSize: "0.8125rem",
          minWidth: "40vw",
        }}
      >
        <div className="flex-spacing" style={{ margin: "1rem 0px" }}>
          <Card>
            <CardContent>
              <TableContainer>
                <Table size="small" aria-label="simple table">
                  <TableBody>
                  <TableRow>
                    <TCell>UTR Number :</TCell>
                    <TCell>
                      <CustomInput
                        style={{
                          minWidth: 0,
                          borderRadius: "3px",
                        }}
                        name="user_reference_number"
                        value={utr}
                        onChange={(e) => setUtr(e.target.value)}
                        placeholder="UTR Number"
                      />
                    </TCell>
                    </TableRow>
                  </TableBody>
                  {paymentMode && paymentMode ==="RAZORPAY" ?<TableBody>
                    <TableRow>
                    <TCell>Razorpay Order Id :</TCell>
                    <TCell>
                      <CustomInput
                        style={{
                          minWidth: 0,
                          borderRadius: "3px",
                        }}
                        name="razorpay_order_id "
                        value={razorpay_order_id}
                        onChange={(e) => setrazorpay_order_id(e.target.value)}
                        placeholder="Razorpay Order Id"
                      />
                    </TCell>
                    </TableRow>
                  </TableBody>:null}
                  <TableBody>
                  <TableRow>
                    <TCell></TCell>
                    <TCell>
                      <Checkbox
                        size="small"
                        checked={duplicate}
                        onChange={(e, checked) => setDuplicate(checked)}
                        color="primary"
                      />
                      Mark Duplicate UTR
                    </TCell>
                    </TableRow>
                  </TableBody>
                  <TableBody>
                  <TableRow>
                    <TCell></TCell>
                    <TCell>
                      <Checkbox
                        size="small"
                        checked={successStatement}
                        onChange={(e, checked) => setSuccessStatement(checked)}
                        color="primary"
                      />
                      Mark Success Statement
                    </TCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={verifyPaymentHandler}
          color="primary"
          variant="contained"
          className="shadow-none common_kissht_btn"
          type="submit"
          disabled={isSubmitting}
        >
          Submit
        </Button>
        <Button
          onClick={() => handleClose(false)}
          variant="contained"
          className="shadow-none common_kissht_btn"
          type="submit"
        //   disabled={isSubmitting || !isValid}
        >
          Close
        </Button>
      </DialogActions>
    </>
  );
};
